import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Layout from "./components/Layout";
import './App.css';
import AuthContext from "./AuthContext";
import ProtectedWrapper from "./ProtectedWrapper";
// pages
import Scheme from './pages/Scheme';
import Ledger from './pages/Ledger';
import Batches from "./pages/Batches";
import Invoice from './pages/Invoice';
import Centre from "./pages/Centre";
import Courses from "./pages/Courses";
import User from './pages/User';
import Trainer from './pages/Trainer';
import Student from './pages/Students';
import Sanction from './pages/Sanction';
import BatchStudent from './pages/BatchStudent';
import Sector from './pages/Sector';
import CryptoJS from 'crypto-js';
import Employee from './pages/Employee';
// details
import TrainerDetails from './components/Trainer/TrainerDetails';
import CentredDetails from './components/Center/CentreDetails';
import CourseDetails from './components/Courses/CourseDetails';
import StudentDetails from './components/Students/StudentsDetail';
import BatchDetails from './components/Batches/BatchDetails';
import LedgerDetails from "./components/Ledger/LedgerDetails";
import EmployeeDetails from './components/Employee/EmployeeDetails';
//reports
import Reports from './pages/Reports'
const SECRET_KEY = 'truelyYoursWelfare2024';

const encryptData = (data) => {
  try {
    return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
  } catch (error) {
    console.error('Encryption error:', error);
  }
};

const decryptData = (data) => {
  try {
    const bytes = CryptoJS.AES.decrypt(data, SECRET_KEY);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedData);
  } catch (error) {
    console.error('Decryption error:', error);
  }
};

const App = () => {
  const [user, setUser] = useState("");
  const [username, setUsername] = useState('');
  const [userType, setUserType] = useState('');
  const [loader, setLoader] = useState(true);
  const [centre, setCentre] = useState('');
  const [trainer, setTrainer] = useState('');
  const [token, setToken] = useState('');

  let myLoginUser = localStorage.getItem("User");

  useEffect(() => {
    if (myLoginUser) {
      const userData = decryptData(myLoginUser);
      setUser(userData.user_id);
      setUserType(userData.user_type);
      setCentre(userData.centre_id);
      setUsername(userData.username);
      setTrainer(userData.trainer_id);
      setToken(userData.accessToken);
      setLoader(false);
    } else {
      setUser("");
      setCentre('');
      setUserType('');
      setTrainer('');
      setLoader(false);
    }
  }, [myLoginUser]);

 // Dependencies to trigger the effect when token or user changes

  const signin = (newUser, callback) => {
    const encryptedUser = encryptData(newUser);
    localStorage.setItem("User", encryptedUser);
    localStorage.setItem("accessToken", newUser.accessToken);
    setUser(newUser.user_id);
    setCentre(newUser.centre_id);
    setTrainer(newUser.trainer_id);
    setUserType(newUser.user_type);
    setUsername(newUser.username);
    setToken(newUser.accessToken);
    callback();
  };
  const signout = () => {
    localStorage.removeItem("User");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("bcentre")
    setUser(null);
    setUserType(null);
    setCentre('');
    setTrainer('');
    setUsername('');
    setToken('');
    window.location.reload(); // Reload page to clear any potential stale data
  };

  let value = { user, userType, username, centre, trainer, token,signin, signout };

  if (loader) {
    return (
      <div
        style={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop:'25rem',
        }}
      >
        <div className='text-center loading-container'>
    {'Loading...'.split('').map((char, index) => (
      <span key={index} className='loading-letter font-bold text-5xl text-indigo-700'>{char}</span>
    ))}
  </div>
      </div>
    );
  }

  return (
    <AuthContext.Provider value={value}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <ProtectedWrapper>
                <Layout />
              </ProtectedWrapper>
            }
          >
            <Route index element={<Dashboard />} />
            <Route 
              path="/centre" 
              element={
                <ProtectedWrapper allowedUserTypes={['Superadmin','Manager','Accounts']} >
                  <Centre />
                </ProtectedWrapper>
              } 
            />
            <Route  
              path="/centre/details"
              element={
                <ProtectedWrapper>
                  <CentredDetails />
                </ProtectedWrapper>
              }
            />
            <Route path="/courses" element={<Courses />} />
            <Route path="/courses/details" element={<CourseDetails />} />
            <Route path="/batches" element={<Batches />} />
            <Route path="/batches/details" element={<BatchDetails />} />
            <Route path="/scheme" element={
              <ProtectedWrapper allowedUserTypes={['Superadmin','Manager']} >
                <Scheme />
              </ProtectedWrapper>
            } />
            <Route path="/trainer" element={<Trainer />} />
            <Route path="/trainer/details" element={<TrainerDetails />} />
            <Route path="/sector" element={<Sector />} />
            <Route 
              path="/users" 
              element={
                <ProtectedWrapper allowedUserTypes={['Superadmin','Manager']} >
                  <User />
                </ProtectedWrapper>
              } 
            />
            <Route path='/ledger/details' element={<LedgerDetails />} />
            <Route path="/students" element={<Student />} />
            <Route path="/student/details" element={<StudentDetails />} />
            <Route path="/batches/students" element={<BatchStudent />} />
            <Route path="/sanction" element={<Sanction />} />
            <Route path="/invoice" element={<Invoice />} />
            <Route 
              path="/ledger" 
              element={
                <ProtectedWrapper>
                  <Ledger />
                </ProtectedWrapper>
              } 
            />
            <Route 
              path="/employee" 
              element={
                <ProtectedWrapper allowedUserTypes={['HR','Superadmin']} >
                  <Employee />
                </ProtectedWrapper>
              } 
            />
            <Route path='/reports' element={<Reports/>}/>
            <Route 
              path="/employee/details" 
              element={
                <ProtectedWrapper allowedUserTypes={['HR','Superadmin']} >
                  <EmployeeDetails />
                </ProtectedWrapper>
              } 
            />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthContext.Provider>
  );
};

export default App;
